/**
 * Promotions Feature Flags
 *
 * Each promotion type can be enabled or disabled independently.
 * Edit this file to turn promotions on/off — no code changes needed elsewhere.
 *
 * When a promotion is disabled:
 *   - The engine will never apply it (even if promo code is entered or bundle conditions are met)
 *   - UI labels/translations remain available but unused
 */

export interface PromotionConfig {
  /** 25% off when a bundle (or equivalent set of individual items) is in the cart (auto, no code needed) */
  bundle_percentage: { enabled: boolean };
  /** 20% off individual products via promo code, first-purchase semantics */
  first_purchase_individual: { enabled: boolean };
  /** 20% off the bundle via promo code, first-purchase semantics */
  first_purchase_bundle: { enabled: boolean };
  /** Percentage off the WHOLE cart (individual products AND bundle) via promo code */
  first_purchase_percentage: { enabled: boolean };
}

export const PROMOTIONS_CONFIG: PromotionConfig = {
  bundle_percentage: { enabled: false },
  first_purchase_individual: { enabled: true },
  first_purchase_bundle: { enabled: true },
  first_purchase_percentage: { enabled: true },
};